define('component/pagination/index', [
    'text!component/pagination/index.html',
    'Vue'
], function (tpl, Vue) {
    'use strict';
    return Vue.extend({
        template: tpl,
        props: {
            count: Number,
            pageIndex: Number,
            pageSize: Number,
            pagerCount: {
                type: Number,
                default: 5
            },
            showTotal: {
                type: Boolean,
                default: true
            },
            showFirstBtn: {
                type: Boolean,
                default: true
            },
            showLastBtn: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                currIndex: this.pageIndex,
                pageCount: 1,
                showPrevMore: false,
                showNextMore: false
            }
        },
        watch: {
            pageIndex: function (n) {
                this.currIndex = n
            },
            count: function () {
                // 接受到服务器数据时
                this.initPagination()
            }
        },
        computed: {
            pageIndexList: function () {
                var pagerCount = this.pagerCount;
                var halfPagerCount = (pagerCount - 1) / 2;

                var currentPage = Number(this.currIndex);
                var pageCount = Number(this.pageCount);

                var showPrevMore = false;
                var showNextMore = false;

                if (pageCount > pagerCount) {
                    if (currentPage > pagerCount - halfPagerCount) {
                        showPrevMore = true;
                    }

                    if (currentPage < pageCount - halfPagerCount) {
                        showNextMore = true;
                    }
                }

                var array = [];

                if (showPrevMore && !showNextMore) {
                    var startPage = pageCount - (pagerCount - 2);
                    for (var i = startPage; i < pageCount; i++) {
                        array.push(i);
                    }
                } else if (!showPrevMore && showNextMore) {
                    for (var i = 2; i < pagerCount; i++) {
                        array.push(i);
                    }
                } else if (showPrevMore && showNextMore) {
                    var offset = Math.floor(pagerCount / 2) - 1;
                    for (var i = currentPage - offset; i <= currentPage + offset; i++) {
                        array.push(i);
                    }
                } else {
                    for (var i = 2; i < pageCount; i++) {
                        array.push(i);
                    }
                }

                this.showPrevMore = showPrevMore;
                this.showNextMore = showNextMore;

                return array;
            }
        },
        methods: {
            initPagination: function () {
                if (this.count > 0) {
                    this.pageCount = Math.ceil(this.count / this.pageSize)
                } else {
                    this.pageCount = 0
                }
            },
            emitPageIndex: function (index) {
                if (Number.isNaN(parseInt(index))) return;
                this.$emit('handle-page-index', index)
            },
            prevPage: function () {
                this.emitPageIndex(this.currIndex - 1)
            },
            nextPage: function () {
                this.emitPageIndex(this.currIndex + 1)
            }
        },
        beforeMount: function () {
            // 未接受到服务器数据时
            this.initPagination()
        }
    })
});
